
// SVG Icon: zoom-reset
export default { id: "terriajs-zoom-reset" };
export const id = "terriajs-zoom-reset";
export const name = "zoom-reset";
